import React from 'react'
import { getFromLS, setToLS } from "../../utils/storage";
import { useEffect } from "react";

const K1Bots = () => {

     useEffect(() => {
            setToLS("url", ["myflows"])
          }, [])

        return (
            <div>K1Bots</div>
        )
}

export default K1Bots